import { ReactComponent as ChevronRightIcon } from './chevron-right.svg';

export default ChevronRightIcon;
